const DEEL_TASK_STATUS = {
  SUCCESS: "Success",
  FAILURE: "Failure",
};

export default DEEL_TASK_STATUS;
